import React from 'react';
import styles from './RelatedRequestHeader.module.scss';
import cn from 'classnames';
import { ReactComponent as RelatedObjectIcon } from '../../../../../../../resource/RelatedObjectIcon.svg';
import { ReactComponent as WarrantyIcon } from '../../../../../../../resource/WarrantyIcon.svg';
import { Tooltip } from 'antd';
import { enumWar } from '../../../../../constants/enumWar';

const RelatedRequestHeader = ({ request, onItemClick }) => {
  const showWarrantyIcon = 1 === request?.garantyId; // На гарантии

  return (
    <div className={styles.root}>
      <div className={styles.leftBlock}>
        <div className={styles.blockIcon}>
          <RelatedObjectIcon />
        </div>
        <div
          className={styles.nameRequest}
          onClick={
            typeof onItemClick === 'function'
              ? () => onItemClick(request.id)
              : undefined
          }
        >{`Заявка №${request.id}`}</div>
      </div>
      <Tooltip title="Гарантия">
        <div className={cn(styles.rightBlock, styles.box, styles.warranty)}>
          {showWarrantyIcon && <WarrantyIcon />}
          {enumWar[request?.garantyId]}
        </div>
      </Tooltip>
    </div>
  );
};

export default RelatedRequestHeader;
